// extracted by mini-css-extract-plugin
export default {"date-block":"U64Z4","date-block_side_main":"n55jq","date-block_view_block":"saL1c","date-block_view_img-block":"QjGu9"};